/**
 * Dashboard view display names that can host the share-a-view tour.
 * Keep in sync with {@link DASHBOARD_VIEW_COMPONENTS} in
 * `dashboard-view-components.tsx`: implemented views that
 * render a share control (excludes Investors, Listings, Communications, Loans).
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export const SHARE_TOUR_ELIGIBLE_DASHBOARD_VIEW_NAMES = [
	"Accounts Payable",
	"Accounts Receivable",
	"Financial Performance",
	"Financial Statements",
	"Work Orders",
	"Leasing",
	"Prospects",
	"Reputation",
	"Reporting",
] as const;

export type ShareTourEligibleDashboardViewName =
	(typeof SHARE_TOUR_ELIGIBLE_DASHBOARD_VIEW_NAMES)[number];
